'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';
import {IrregularitiesNewDialogCtrl} from './irregularitiesnewdialogctrl.js';
import {irregularityModel} from '../../models/irregularitymodel.js';

export class IrregularitiesIndexCtrl extends ListCtrl
{
	$mdDialog;
	
	$scope;
	
	classif;
	
	storageNames = {
		query: 'IrregularitiesListCtrlQuery'
	};
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.$scope = $scope;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = jsDataService.get('cfgClassif');
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
	}
	
	createNew(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', IrregularitiesNewDialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'irregularities/new_irregularity_dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
			}
		}).then((results) => {
			if(this.jsDataService.get('cfgCreateUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgCreateUrl'),
					method: 'POST',
					data: {
						project: results.id,
					}
				}).then((response) => {
					this.loadData();
				}, () => {});
			}
		}, (results) => {
		});
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new irregularityModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof irregularityModel){
			return row.getValue(col);
		}
		return row[col];
	}
    exportList(){
        const queryObj = {
            filters: JSON.stringify(this.query.filters),
            limit:   this.query.limit,
            page:    this.query.page,
            order:   this.query.order,
        };

        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        queryObj.tz = userTz;

        const query = new URLSearchParams(queryObj);

        const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = `${this.cfgExportUrl}?${query.toString()}`;
        a.download = `Irregularity_${ts}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

}